import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { LinkContainer } from "react-router-bootstrap";
import logo from "../img/logo.png";
import { useContext, useState } from "react";
import { BpContext } from "../context/AppContext";
import { Link } from "react-router-dom";
import AuthService from "../services/auth.service";
import { Button } from "react-bootstrap";
function Header() {
  const loggedInUser = useContext(BpContext);
  return (
    <Navbar bg="light" expand="lg" className="d-print-none">
      <Container>
        <LinkContainer to={"/"}>
          <Navbar.Brand>
            <img
              src={logo}
              width="30"
              height="30"
              className="d-inline-block align-top"
              alt="KAPID"
            />
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="menu-bar" />
        <Navbar.Collapse id="menu-bar">
          <Nav>
            <LinkContainer to={"/onboard"} activeClassName="active">
              <Nav.Link
                // className={activeMenu === "onboarding" ? "active" : ""}
                id="onboarding"
                // onClick={handleMenu}
              >
                Onboard
              </Nav.Link>
            </LinkContainer>
            {loggedInUser.loggedIn && (
              <>
                <LinkContainer to={"/patient"} activeClassName="active">
                  <Nav.Link
                    // onClick={handleMenu}
                    id="patient"
                    // className={activeMenu === "patient" ? "active" : ""}
                  >
                    Patient
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/services"} activeClassName="active">
                  <Nav.Link
                    // onClick={handleMenu}
                    id="searchImport"
                    // className={activeMenu === "searchImport" ? "active" : ""}
                  >
                    Search & Import
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/booking"} activeClassName="active">
                  <Nav.Link
                    // onClick={handleMenu}
                    id="pos"
                    // className={activeMenu === "pos" ? "active" : ""}
                  >
                    Booking
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/pos"} activeClassName="active">
                  <Nav.Link
                    // onClick={handleMenu}
                    id="pos"
                    // className={activeMenu === "pos" ? "active" : ""}
                  >
                    PoS
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/erx/1/1"} activeClassName="active">
                  <Nav.Link
                    // onClick={handleMenu}
                    id="erx"
                    // className={activeMenu === "erx" ? "active" : ""}
                  >
                    Erx
                  </Nav.Link>
                </LinkContainer>
                <NavDropdown title="Staff" id="staff-dropdown">
                  <LinkContainer to={"/staff/new"} activeClassName="active">
                    <NavDropdown.Item>New Employee</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
                <NavDropdown title="Masters" id="master-dropdown">
                  <LinkContainer to={"/masters/lob"} activeClassName="active">
                    <NavDropdown.Item>Line of Business</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to={"/masters/posd"} activeClassName="active">
                    <NavDropdown.Item>
                      Point of Service Delivery
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to={"/masters/specialization"}
                    activeClassName="active"
                  >
                    <NavDropdown.Item>Business Specialization</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer
                    to={"/masters/usertypes"}
                    activeClassName="active"
                  >
                    <NavDropdown.Item>User Types</NavDropdown.Item>
                  </LinkContainer>
                  {/* <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
                </NavDropdown>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            {loggedInUser.loggedIn ? (
              <NavDropdown title={loggedInUser.kapid_id} id="profile-dropdown">
                {/* <LinkContainer to={"/businesses"}>
                  <NavDropdown.Item>My account</NavDropdown.Item>
                </LinkContainer> */}
                <LinkContainer to={"/businesses"} activeClassName="active">
                  <NavDropdown.Item>My Businesses</NavDropdown.Item>
                </LinkContainer>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Button}
                  onClick={() => AuthService.logout()}
                >
                  Sign-Out
                </NavDropdown.Item>
                {/* <LinkContainer to={"/auth/logout"}>
                </LinkContainer> */}
              </NavDropdown>
            ) : (
              <Link to={"/auth/login"} className="btn btn-outline-success">
                Login
              </Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
